export const PRIMARY_PROMPTS_COUNT = 3;
